import _ from "@lodash";
import { Card, CardContent, Typography, withStyles } from "@material-ui/core";
import { changeContentPainel, getUrlHelp } from "app/Core/Components/PainelFixoDireita/Store/Actions";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import React from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import XAPPButton from "../Button/XAPPButton";
import * as Actions from "./Store/Actions/ChecklistEmpresaActions";
import reducer from "./Store/Reducers/ChecklistEmpresaReducer";


const styles = theme => ({
    iconCount: {
        //"backgroundColor": theme.palette.type === "dark" ? "#ffffff1a" : "#00000014",
        "backgroundColor": theme.palette.primary.main,
        "height": "fit-content",
        "&:hover": {
            "backgroundColor": theme.palette.primary.main,
        }
    },
    completed: {
        "backgroundColor": `${theme.palette.primary.main}99`,
        "&:hover": {
            "backgroundColor": `${theme.palette.primary.main}99`,
        }
    },
    bgPainel: {
        backgroundColor: theme.palette.background.default,
    }
});

window.onClickCardHelp = (id) => {
    if (document.getElementById("collapse_" + id).classList.contains("hidden"))
        document.getElementById("collapse_" + id).classList.remove("hidden");
    else
        document.getElementById("collapse_" + id).classList.add("hidden");
};

class ChecklistEmpresa extends XAPPComponent {

    componentDidMount() {
        this.props.list(this.props.xappRouteParams);
    }

    componentDidUpdate(prevProps) {
        if (this.props.reducer.error) {
            this.props.showMessage({
                message: this.props.reducer.error,
                variant: "error"
            });
            this.props.reducer.error = null;
        }
        if (this.props.reducer.info) {
            this.props.showMessage({
                message: this.props.reducer.info,
                variant: "success"
            });
            this.props.reducer.info = null;
        }

        const { reducer } = this.props;
        if (!_.isNull(prevProps.reducer.data) && !_.isNull(reducer.data) && reducer.data.length > 0 && !_.isEqual(reducer.data, prevProps.reducer.data)) {
            this.openPainelContent();
        }
    }

    getModulos = () => {
        const { reducer } = this.props;
        var AModulos = [];
        if (!_.isNull(reducer.data) && reducer.data.length > 0) {
            reducer.data.forEach(item => {
                if (_.findIndex(AModulos, { id: item.modulo }) < 0) {
                    AModulos.push({ id: item.modulo, nome: item.modulodescricao });
                }
            });
        }
        return AModulos;
    };

    getStatus = id => {
        const totais = this.getCount(id);
        let icon = "ampulheta";
        let status = "Pendente";

        if (totais.count === totais.total) {
            icon = "done";
            status = "Concluído";
        }
        else if (0 < totais.count && totais.count < totais.total) {
            icon = "run";
            status = "Em progresso";
        }

        return (
            <XAPPButton
                type="Icon"
                className="p-8"
                tooltip={{ placement: "top", title: status }}
                onClick={() => { }}
                iconProps={"text-16"}
                icon={icon}
                noHover
            />
        );
    };

    checkConcluido = id => {
        const totais = this.getCount(id);
        return totais.count === totais.total;
    };

    getStatusItem = item => {
        const { getUrlHelp } = this.props;
        // if (item.status === 1)
        //     return (
        //         <XAPPButton
        //             type="Icon"
        //             className="p-8"
        //             tooltip={{ placement: "top", title: "Concluído" }}
        //             onClick={() => { }}
        //             iconProps={"text-16"}
        //             icon={"done"}
        //             noHover
        //         />
        //     );
        if (item.acesso === 0)
            return (
                <XAPPButton
                    type="Icon"
                    className="p-8"
                    tooltip={{ placement: "top", title: "Pendente" }}
                    onClick={() => { }}
                    iconProps={"text-16"}
                    icon={"ampulheta"}
                    noHover
                />
            );
        return (
            <XAPPButton
                type="Icon"
                className="p-8"
                tooltip={{ placement: "top", title: "Acessar" }}
                onClick={() => getUrlHelp(item.destino)}
                iconProps={"text-16"}
                icon={"play_arrow"}
                key={"iconExecutarPasso"}
            />
        );
    };

    getStatusCount = id => {
        const totais = this.getCount(id);
        return (
            <Typography className="whitespace-no-wrap">{`( ${totais.count} / ${totais.total} )`}</Typography>
        );
    };

    getCount = id => {
        const { data } = this.props.reducer;
        const total = _.filter(data, { modulo: id }).length;
        const count = _.filter(data, { modulo: id, status: 1 }).length;
        return { count, total, diff: total - count };
    };

    getNextStep = id => {
        const { data } = this.props.reducer;
        return _.filter(data, { modulo: id, status: 0 })[0];
    };

    openPainelContent = () => {
        const { changeContentPainel, classes, reducer } = this.props;
        const AModulos = this.getModulos();
        changeContentPainel(
            <div className={clsx(classes.bgPainel, "p-8 pt-0 relative overflow-y-auto")} style={{ height: "90vh" }}>
                {AModulos.length > 0 ?
                    <div className="flex flex-col gap-6">
                        {AModulos.map((modulo, x) => (
                            <Card key={modulo.id}>
                                <CardContent className="flex p-8 cursor-pointer max-w-384 border-b-1" id={"card_" + modulo.id} onClick={() => window.onClickCardHelp(modulo.id)}>
                                    <div className="flex items-center pr-6 border-r-1">
                                        <XAPPButton
                                            type="Icon"
                                            className={clsx(classes.iconCount, "p-8", this.checkConcluido(modulo.id) && classes.completed)}
                                            onClick={() => { }}
                                            iconProps={"text-16 min-w-16 text-white"}
                                            icon={`${x + 1}`}
                                        />
                                    </div>
                                    <div className="w-full">
                                        <div className="flex w-full items-center max-w-320">
                                            {this.getStatus(modulo.id)}
                                            <Typography className="whitespace-no-wrap w-full overflow-x-auto">{modulo.nome}</Typography>
                                            {this.getStatusCount(modulo.id)}
                                        </div>
                                        {this.getCount(modulo.id).diff > 0 &&
                                            <div className="flex w-full items-center max-w-320">
                                                <XAPPButton
                                                    type="Icon"
                                                    className=""
                                                    noHover
                                                    iconProps={"text-16"}
                                                    icon={"arrow_large_right"}
                                                    key={"iconArrowRight"}
                                                />
                                                <Typography className="whitespace-no-wrap w-full overflow-x-auto">{this.getNextStep(modulo.id).nome}</Typography>
                                                {this.getStatusItem(this.getNextStep(modulo.id))}
                                            </div>
                                        }
                                    </div>
                                </CardContent>
                                <CardContent className="pt-0 hidden" id={"collapse_" + modulo.id}>
                                    {_.filter(reducer.data, { modulo: modulo.id }).map((item, y) => (
                                        <div className="flex w-full items-center justify-between" key={"item_" + y}>
                                            <XAPPButton
                                                type="Icon"
                                                className="py-8"
                                                onClick={() => { }}
                                                iconProps={"text-16"}
                                                icon={`${y + 1}`}
                                                noHover
                                            />
                                            <Typography className="whitespace-no-wrap w-full overflow-x-auto">{item.nome}</Typography>
                                            {this.getStatusItem(item)}
                                        </div>
                                    ))}
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                    :
                    <div className="w-full flex flex-col items-center text-center">
                        <Typography>{"Ops, ocorreu um erro inesperado. Por favor entre em contato com o administrador do sistema para solucionarmos o mais breve possível. Obrigado."}</Typography>
                    </div>
                }
                <div className="flex w-full py-24 justify-center">
                    <XAPPButton
                        type="Button"
                        className=" text-initial"
                        variant="outlined"
                        color="primary"
                        onClick={() => this.props.list(this.props.xappRouteParams)}
                        iconProps={"mr-8"}
                        icon={"refresh"}
                        label={"Atualizar"}
                    />
                </div>
            </div>
        );
    };


    render() {
        const { data = null } = this.props.reducer;
        return (
            <React.Fragment>
                <XAPPButton
                    type="Icon"
                    className=""
                    tooltip={{ placement: "top", title: "Primeiros passos" }}
                    onClick={() => this.openPainelContent()}
                    iconProps={"text-16"}
                    icon={"checklist"}
                    key={"iconWizardDialog"}
                    badge={!_.isNull(data) ? _.filter(data, { status: 0 }).length : 0}
                />
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        showMessage: AppActions.showMessage,
        changeContentPainel: changeContentPainel,
        getUrlHelp: getUrlHelp,
    }, dispatch);
}

function mapStateToProps({ ChecklistEmpresa }) {
    return {
        reducer: ChecklistEmpresa
    };
}

export default withReducer("ChecklistEmpresa", reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ChecklistEmpresa))));
